<div class="wetter_content_container">
  <h3>Vorhersagen</h3>
  <div class="bericht-text-container">
    <span
      class="bericht-text-sub-label">{{berlinBrandenburgVideotextVorhersagen?.tag00?.datum | date: 'EEE dd.MM'}}</span>
    <p>{{berlinBrandenburgVideotextVorhersagen?.tag00?.kurzbeschreibung}}</p>
    <span
      class="bericht-text-sub-label">Nacht zu {{berlinBrandenburgVideotextVorhersagen?.nachtZuTag01?.datum | date: 'EEE dd.MM'}}</span>
    <p>{{berlinBrandenburgVideotextVorhersagen?.nachtZuTag01?.kurzbeschreibung}}</p>
    <span
      class="bericht-text-sub-label">{{berlinBrandenburgVideotextVorhersagen?.tag01?.datum | date: 'EEE dd.MM'}}</span>
    <p>{{berlinBrandenburgVideotextVorhersagen?.tag01?.kurzbeschreibung}}</p>
  </div>
  <h3>Aussichten</h3>
  <div class="bericht-text-container">
    <span class="bericht-text-sub-label">5 Tage</span>
    <p>{{berlinBrandenburgVideotextAussichten?.aussichten_5Tage}}</p>
  </div>
  <div class="bericht-text-container" style="border: none">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="datum">
        <th mat-header-cell *matHeaderCellDef>Datum</th>
        <td mat-cell *matCellDef="let element">{{element?.datum | date: 'EEE dd.MM'}}</td>
      </ng-container>
      <ng-container matColumnDef="maxTemp">
        <th mat-header-cell *matHeaderCellDef>Max Temp</th>
        <td mat-cell *matCellDef="let element">{{element?.maxTempInGradCelsius}} °C</td>
      </ng-container>
      <ng-container matColumnDef="minTemp">
        <th mat-header-cell *matHeaderCellDef>Min Temp</th>
        <td mat-cell *matCellDef="let element">{{element?.minTempInGradCelsius}} °C</td>
      </ng-container>
      <ng-container matColumnDef="regen">
        <th mat-header-cell *matHeaderCellDef>Niederschlag</th>
        <td mat-cell *matCellDef="let element">{{element?.regenInProzent}} %</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

  </div>


</div>
